import React, { FC, useMemo } from 'react';
import Widget from 'src/components/Widget';
import { useTheme } from '@mui/material';
import { DashboardDataReceipts } from 'src/api/services/types';
import ReceiptsSummaryContent from './Content';
import { ApiServiceImpl } from 'src/api/services';
import { TimeSpan } from 'src/viewsTypes';

const title = 'סיכום חשבוניות חודשי';
type DataType = DashboardDataReceipts['total'];
const ReceiptsSummary: FC = () => {
  const timeSpan: TimeSpan = useMemo(() => ({ timeUnit: 'D', count: 30 }), []);
  const { spacing } = useTheme();
  const size = useMemo(
    () => ({ width: spacing(30), height: spacing(40) }),
    [spacing],
  );

  return (
    <Widget<DataType>
      title={title}
      filters={{ timeSpan }}
      service={ApiServiceImpl.getReceiptsSummary}
      size={size}
      isWithContentFade={false}
      Content={ReceiptsSummaryContent}
    />
  );
};

export default ReceiptsSummary;
